export const DriverInformationFieldNames = {
  DriverId: 'driverId',
  DriverName: 'driverName',
  DriverLicenseNumber: 'driverLicenseNumber',
  DriverEmail: 'driverEmail',
  DriverPhone: 'driverPhone',
} as const;

export type DriverInformationFields = {
  [DriverInformationFieldNames.DriverId]?: string;
  [DriverInformationFieldNames.DriverName]?: string;
  [DriverInformationFieldNames.DriverLicenseNumber]?: string;
  [DriverInformationFieldNames.DriverEmail]?: string;
  [DriverInformationFieldNames.DriverPhone]?: string;
};
